import React, { useState, useCallback } from "react";
import moment from "moment";
import Status from "../../../../Utils/Status/Status";
import { Dialog } from "primereact/dialog";
import Sharing from "./Sharing/Sharing";
import toast from "react-hot-toast";

const fmt = require("indian-number-format");

export default function ListCard({ item, reload, userType }) {
  const [sharing, setSharing] = useState(false);

  // Memoized event handlers
  const handleSuperEdit = useCallback(() => {
    window.user_id = item.super_id;
    window.openeditSuper?.();
  }, [item.super_id]);

  const handleEdit = useCallback(() => {
    window.user_id = item.id;
    window.masterModalOpen?.();
  }, [item.id]);

  const handleSharingOpen = useCallback(() => setSharing(true), []);
  const handleSharingClose = useCallback(() => setSharing(false), []);

  const formatNumber = (num) => fmt.format(parseFloat(num || 0).toFixed(0));

  const handleCopyMsg = () => {
    const msg = `
Welcome To ${window.APP_NAME}

Name : ${item.name}  
Master User Username : ${item.username}
Master User Password : ${"123123" || "*****"}

Platform: ${window.WEBSITE_LINK}`;

    navigator.clipboard.writeText(msg);
    toast.success("Copied user message");
  };

  return (
    <div onDoubleClick={handleCopyMsg} className="menuContainer addHight text">
      {/* Super Column */}
      {userType !== 2 && (
        <div onClick={handleSuperEdit} className="menuUsername">
          <div className="user_id">{item.super_username}</div>
        </div>
      )}

      {/* Username */}
      <div onClick={handleEdit} className="menuUsername">
        <div className="user_id">{item.username}</div>
      </div>

      {/* Booked (Profit/Loss) */}
      <div
        className={`menuUsername ${
          item.profit_loss > 0 ? "buytext" : "selltext"
        }`}
      >
        {formatNumber(item.profit_loss)}
      </div>
      {/* Booked (Profit/Loss) */}
      <div
        className={`menuUsername ${
          item.net_profit_loss > 0 ? "buytext" : "selltext"
        }`}
      >
        {formatNumber(item.net_profit_loss)}
      </div>

      {/* Sharing */}
      <div onClick={handleSharingOpen} className="menuName">
        <div className="user_id">{formatNumber(item.sharing)}</div>
      </div>

      <div className={`menuName`}>
        <div className="user_id">{item.tpassword}</div>
      </div>

      {/* Status Columns */}
      <div className="menuName">
        <Status id={item.id} status={item.trade} type="TRADE" />
      </div>
      <div className="menuName">
        <Status id={item.id} status={item.only_sq} type="ONLY_SQ" />
      </div>
      <div className="menuName">
        <Status id={item.id} status={item.status} type="STATUS" />
      </div>

      {/* IP Address */}
      <div className="menuName">{item.ip || "N/A"}</div>

      {/* Dates */}
      <div className="menuDate flex flex-col items-center justify-center">
        <div className="extraSmall">
          {moment(item.date_created).format("DD-MM-YYYY")}
        </div>
        <div className="small">
          {moment(item.date_created).format("HH:mm:ss")}
        </div>
      </div>

      <div className="menuDate small flex flex-col items-center justify-center">
        {item.last_login_date ? (
          <>
            <div className="extraSmall">
              {moment(item.last_login_date).format("DD-MM-YYYY")}
            </div>
            <div className="small">
              {moment(item.last_login_date).format("HH:mm:ss")}
            </div>
          </>
        ) : (
          "N/A"
        )}
      </div>

      {/* Edit Button */}
      <div className="menuName">
        <button
          onClick={handleEdit}
          className={`bg-[var(--primary)] relative flex items-center justify-center gap-1 px-2 py-1 text-xs font-medium uppercase rounded-md transition-all duration-300 cursor-pointer hover:opacity-80 text-white border-2 border-[var(--hover)] shadow-[0_0_6px_rgba(255,255,255,0.4)]`}
        >
          EDIT
        </button>
      </div>

      {/* Sharing Dialog */}
      <Dialog
        visible={sharing}
        onHide={handleSharingClose}
        closeOnEscape
        closeIcon
        id="modal"
        position="center"
        transitionOptions={false}
        focusOnShow={false}
      >
        <Sharing item={item} close={handleSharingClose} reload={reload} />
      </Dialog>
    </div>
  );
}
